// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/advisories.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../core/common_pb";
import { file_proto_model_entity_contact } from "../entity/contact_pb";

/**
 * Describes the file proto/model/trip/advisories.proto.
 */
export const file_proto_model_trip_advisories = /*@__PURE__*/
  fileDesc("CiFwcm90by9tb2RlbC90cmlwL2Fkdmlzb3JpZXMucHJvdG8SBmNhcm1lbiK9AQoOVHJhdmVsQWR2aXNvcnkSKgoFbGV2ZWwYASABKA4yGy5jYXJtZW4uVHJhdmVsQWR2aXNvcnlMZXZlbBIPCgdjb250ZW50GAIgAygJEjEKFGVtYmFzc3lfY29udGFjdF9pbmZvGAMgASgLMhMuY2FybWVuLkNvbnRhY3RJbmZvEjsKHmlzc3VpbmdfYXV0aG9yaXR5X2NvbnRhY3RfaW5mbxgEIAEoCzITLmNhcm1lbi5Db250YWN0SW5mbyJKChNTYWZldHlDb25zaWRlcmF0aW9uEg8KB2NvbnRlbnQYASABKAkSIgoIc2V2ZXJpdHkYAiABKA4yEC5jYXJtZW4uU2V2ZXJpdHkihgEKFURlc3RpbmF0aW9uQWR2aXNvcmllcxIxChF0cmF2ZWxfYWR2aXNvcmllcxgBIAMoCzIWLmNhcm1lbi5UcmF2ZWxBZHZpc29yeRI6ChVzYWZldHlfY29uc2lkZXJhdGlvbnMYAiADKAsyGy5jYXJtZW4uU2FmZXR5Q29uc2lkZXJhdGlvbirXAQoTVHJhdmVsQWR2aXNvcnlMZXZlbBIlCiFUUkFWRUxfQURWSVNPUllfTEVWRUxfVU5TUEVDSUZJRUQQABIgChxUUkFWRUxfQURWSVNPUllfTEVWRUxfTk9STUFMEAESIQodVFJBVkVMX0FEVklTT1JZX0xFVkVMX0NBVVRJT04QAhIrCidUUkFWRUxfQURWSVNPUllfTEVWRUxfUkVDT05TSURFUl9UUkFWRUwQAxInCiNUUkFWRUxfQURWSVNPUllfTEVWRUxfRE9fTk9UX1RSQVZFTBAEQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_proto_model_core_common, file_proto_model_entity_contact]);

/**
 * Describes the message carmen.TravelAdvisory.
 * Use `create(TravelAdvisorySchema)` to create a new message.
 */
export const TravelAdvisorySchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_advisories, 0);

/**
 * Describes the message carmen.SafetyConsideration.
 * Use `create(SafetyConsiderationSchema)` to create a new message.
 */
export const SafetyConsiderationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_advisories, 1);

/**
 * Describes the message carmen.DestinationAdvisories.
 * Use `create(DestinationAdvisoriesSchema)` to create a new message.
 */
export const DestinationAdvisoriesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_advisories, 2);

/**
 * Describes the enum carmen.TravelAdvisoryLevel.
 */
export const TravelAdvisoryLevelSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_advisories, 0);

/**
 * @generated from enum carmen.TravelAdvisoryLevel
 */
export const TravelAdvisoryLevel = /*@__PURE__*/
  tsEnum(TravelAdvisoryLevelSchema);

